import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-car-insurance-whyyouneed',
  imports: [TranslatePipe],
  templateUrl: './car-insurance-whyyouneed.component.html',
  styleUrl: './car-insurance-whyyouneed.component.scss'
})
export class CarInsuranceWhyyouneedComponent {

}
